"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshWithApi = refreshWithApi;
exports["default"] = refreshTokens;

var _throttle2 = _interopRequireDefault(require("lodash/throttle"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _getPublicRequest = require("../requests/getPublicRequest");

var _errors = require("../errors");

var _manageTokens = require("./manageTokens");

var _normalizeTokens = require("./normalizeTokens");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function refreshWithApi(client, refreshToken) {
  var path = "".concat(client.context.api.host, "/refresh");
  return (0, _getPublicRequest.getPublicRequest)(client).then(function (request) {
    return request.post(path).send({}).auth(refreshToken, {
      type: 'bearer'
    }).then(function (res) {
      return (0, _normalizeTokens.normalizeTokens)(res.body);
    })["catch"](_errors.rejectWithNormalizedErr);
  });
}

// throttle api request for concurrent requests
var throttledApiRefresh = (0, _throttle2["default"])(refreshWithApi, 10 * 1000, {
  leading: true
});

function refreshTokens(client) {
  var refreshProvider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : throttledApiRefresh;
  var refreshToken = (0, _manageTokens.getToken)(client, 'refreshToken');
  if (!refreshToken) return Promise.reject('no refresh token');
  return refreshProvider(client, refreshToken).then(function (tokens) {
    (0, _manageTokens.updateTokens)(client, tokens);
    return tokens.idToken;
  })["catch"](function (err) {
    if (err.statusCode < 500) {
      _loglevel["default"].warn("received ".concat(err.statusCode, " while refreshing token, clearing tokens"));

      (0, _manageTokens.clearTokens)(client);
    }

    return Promise.reject(err);
  });
}